import { Grid, TextField, Chip } from '@material-ui/core';
import companyTypesMaster from 'assets/company-types';
import { flatten } from 'lodash';
import { Autocomplete, AutocompleteChangeReason } from '@material-ui/lab';
import { useState, useMemo, useEffect } from 'react';

export interface Option {
  label: string;
  value: number;
}

export const CompanyTypeEditor = ({
  value = null,
  onChange = null,
  dialogFirstRender = false,
}: {
  value?: Option[];
  onChange?: (value: Option[]) => any;
  dialogFirstRender?: boolean;
}) => {
  const [categoryTuple, setCategoryTuple] = useState<Option[]>(value || []);

  useEffect(() => {
    onChange(categoryTuple);
  }, [categoryTuple]);

  useEffect(() => {
    if (!dialogFirstRender) {
      setCategoryTuple(value || []);
    }
  }, [value, dialogFirstRender]);

  const handleChange = useMemo(() => {
    const type = (_evt: any, value: Option[], reason: AutocompleteChangeReason) => {
      if (reason === 'clear') {
        setCategoryTuple([]);
      }
      setCategoryTuple(c => {
        const newTuple = [...value];
        return newTuple;
      });
    };
    return {
      type,
    };
  }, []);

  return (
    <Grid container spacing={3} direction="column">
      <Grid item xs>
        <Autocomplete
          style={{ width: '500px' }}
          multiple
          value={categoryTuple}
          onChange={handleChange.type}
          options={categoryOptions.types}
          getOptionLabel={(option: Option) => option.label}
          size="small"
          renderInput={TypesTextField}
          getOptionSelected={(option, value) => option.value === value.value}
          renderTags={(value, getTagProps) => {
            return value.map((option, index) =>
              //   <Chip color="primary" label={option.label} {...getTagProps({ index })} />
              // )
              index == 0 ? (
                <Chip color="primary" label={option.label} {...getTagProps({ index })} />
              ) : (
                <Chip color="secondary" label={option.label} {...getTagProps({ index })} />
              )
            );
          }}
        />
      </Grid>
    </Grid>
  );
};
const createTextFields =
  (label: string, helperText: string = null) =>
  props =>
    <TextField {...props} helperText={helperText} label={label} variant="outlined" />;
const getOptionSelected = (value: { value: number }, other: { value: number }) =>
  value.value === other.value;
const getLabel = (opt: { label: string }) => opt && opt.label;
const getChildGroupBy = (option: { parentName: string }) => option.parentName;
const SubTypesTextField = createTextFields(
  'Subtype',
  'The subtypes of the company, select from dropdown.'
);
const TypesTextField = createTextFields('Type', 'The types of the company, select from dropdown');
const categoryOptions = {
  types: companyTypesMaster.map(({ id, type }) => ({ label: type, value: id })),
  subTypes: flatten(
    companyTypesMaster
      .filter(t => t.child.subtypes.length)
      .map(t =>
        t.child.subtypes.map(s => ({
          label: s.subtype,
          value: s.id,
          parent: t.id,
          parentName: t.type,
        }))
      )
  ),
  services: flatten(
    companyTypesMaster
      .filter(t => t.child.services.length)
      .map(t =>
        t.child.services.map(s => ({
          label: s.service,
          value: s.id,
          parent: t.id,
          parentName: t.type,
        }))
      )
  ),
};
